export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-02_04.8f381434.jpg";